import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import servicii from "../images/servicii-img.png";
import smallServicii from "../images/small-servicii.png";
import "../css/main.css";

const TerapieGrup = () => {
  return (
    <div>
      <Header />

      <div className="contributii blog servicii serviciu-page">
        <div className="container">
          <div className="info-section text-b">AWARE</div>
          <h1 className="text-b">Terapia de grup</h1>
          <p>
            Psihoterapia de grup este un proces psihoterapeutic in care mai
            multe persoane se intalnesc, sub ghidjul unui psihoterapeut, pentru
            a explora dificultati emotionale, relationale sa de viata. Grupul
            devine , prin prezenta, dedicare si un bun ghidaj, un spatiu sigur,
            confidential, in care participantii descopera resurse de schimbare
            si crestere personala.
          </p>
          <p>
            Intr o maniera mai putin teoretica, grupul asigura acel “impreuna”
            de care avem nevoie pentru a simti ca nu suntem singuri si care
            poate veni in sprijinul nevoii de apartenenta.
          </p>
          <p>
            Fiind o forma de organizare bine documentata, psihoterapia de grup
            este sustinuta de o serie de factori psihoterapeutici importanti:
          </p>
          <ul>
            <li>importanta relatilor interpersonale</li>
            <li>experienta emotionala corectiva</li>
            <li>recunoasterea tiparelor de comportament</li>
            <li>dezvoltarea abilitatilor de socializare</li>
            <li>campul ca sursa de suport si siguranta.</li>
          </ul>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TerapieGrup;
